import React, { useEffect, useState} from "react";
import Header from "../components/Header";
import { Link, useLocation ,useParams  } from "react-router-dom";
import Product1 from "../components/Product1";
import Product2 from "../components/Product2";
import Sheet from 'react-modal-sheet';
import { BsSliders, BsCaretDownFill, BsArrowClockwise, BsListUl, BsGridFill } from "react-icons/bs";

import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

import { useAxios } from "../services/useAxios";
import { useTranslation } from 'react-i18next';


export default function EventProduct() {
    const { t } = useTranslation();
    
    const [isOpen, setOpen] = useState(false);

    const location = useLocation();   
    const [cate, setCate] = useState({});
   
    let {id} = useParams();
    const [listMode, setListMode] = useState("grid");
    const [selectCate, setSelectCate] = useState(id);
    const [goodsHashtagListStr, setGoodsHashtagListStr] = useState(null);
    
    const [data, setData] = useState({});
    const [dataList, setDataList] = useState([]);
    const [tagCheckList, setTagCheckList] = useState([]);
    const [selectOrder, setSelectOrder] = useState('popular');
    const [selectDlvyFree, setDlvyFreeAt] = useState(false);
    const [selectDlvyToday, setDlvyTodayAt] = useState(false);
    const lang = localStorage.getItem("language") || "ko";
    const [request] = useAxios();

    const handleSingleCheck = (checked, id) => {
        if (checked) {
          // 단일 선택 시 체크된 아이템을 배열에 추가
          setTagCheckList(prev => [...prev, id]);
        } else {
          // 단일 선택 해제 시 체크된 아이템을 제외한 배열 (필터)
          setTagCheckList(tagCheckList.filter((el) => el !== id));
        }
      };

    const [page, setPage] = useState(0);

    const fn_clTab = (obj) => {
    
        if(obj!==null){
            setSelectCate(obj.goodsClSn);
        }else{
            setSelectCate(id);
        }
        
    } 
    
    const handleSelect = (e) => {
        setSelectOrder(e.target.value);
    };
   

    const fetchData = async (pageIndex) => {        
        const response = await request.post("/app/goods/getGoodsEventTyListAPI", {
            nationSeCode : lang,
            eventSn : id,
            dlvyFreeAt :selectDlvyFree===true? 'Y':'N',
            dlvyTodayAt : selectDlvyToday===true? 'Y':'N',
            orderBy : selectOrder,
            goodsHashtagListStr: goodsHashtagListStr,
            pageIndex : pageIndex

        });
        if(response.data.resultCode === 200){      
            console.log(response.data.result)     
            setData(response.data.result);                                    
            if(pageIndex ===1){
                setDataList(response.data.result.resultList);
            }else{
                setDataList((prevData) => [...prevData, ...response.data.result.resultList]);
            }       
        }            
    };

    useEffect(() => {        
        if(page > 0){
            fetchData(1)     
        }
      }, [selectCate, selectOrder, goodsHashtagListStr]);


   
  useEffect(() => {
    if(page > 0){
        fetchData(page);    
    }

  }, [page]);

  const fn_search = () => {
    setOpen(false)
    let listStr ='';
    let i = 0;
    tagCheckList.forEach((item) =>{
		if(i > 0){
			listStr += '|';
		}
		listStr += ',' + item + ',';
		i++;
	});	
    setGoodsHashtagListStr(listStr)
  }

  const handleObserver = (entries) => {
    const target = entries[0];
    if (target.isIntersecting ) {
        setPage((prevPage) => prevPage + 1);
    }
  };

  useEffect(() => {
    const observer = new IntersectionObserver(handleObserver, {
      threshold: 0, //  Intersection Observer의 옵션, 0일 때는 교차점이 한 번만 발생해도 실행, 1은 모든 영역이 교차해야 콜백 함수가 실행.
    });
    // 최하단 요소를 관찰 대상으로 지정함
    const observerTarget = document.getElementById("observer");
    // 관찰 시작
    if (observerTarget) {
      observer.observe(observerTarget);
    }
  }, []);

    return(
        <div>
            <div className="backGround bgBlue"></div>
            <div className="headFixed backGround bgBlue ephd">
                <Header type="cart" pageTitle={data.eventVO?.eventManageInfo.eventDc}/>                       
            </div>

            <div className="categoriesWr ep">
                <div className="fliterWr epfw">
                    <button 
                        type="button" 
                        className={"filterBtn "+ (tagCheckList.length!==0?' active':null)}
                        onClick={(e) => {
                            e.preventDefault(); 
                            e.stopPropagation(); 
                            setOpen(true);
                        }}
                    >
                        <BsSliders />
                        <span>HASHTAG</span>
                    </button>
                    {/* <select onChange={handleSelect} className="sort">
                        <option value="popular">{t(`Message.goods_list_screen_ordr_popular`)}</option>
                        <option value="recent">{t(`Message.goods_list_screen_ordr_recent`)}</option>
                        <option value="lowPrice">{t(`Message.goods_list_screen_ordr_lowPrice`)}</option>
                        <option value="highPrice">{t(`Message.goods_list_screen_ordr_highPrice`)}</option>
                        <option value="order">{t(`Message.goods_list_screen_ordr_order`)}</option>
                        <option value="review">{t(`Message.goods_list_screen_ordr_review`)}</option>
                    </select> */}
                    <div className="dfceG6">
                        <button type="button" className={listMode === 'grid'?"swapBtn active":"swapBtn"} onClick={(e)=>setListMode("grid")}><BsGridFill /></button>
                        <button type="button" className={listMode === 'list'?"swapBtn active":"swapBtn"} onClick={(e)=>setListMode("list")}><BsListUl /></button>
                    </div>
                </div>

                {listMode === 'grid'?(
                    <div className="ct2">
                    {dataList && dataList.map((obj, index) => (
                        
                    <Product1 key={index}
                        img={"https://www.salee.co.kr/com/cmm/getGoodsImageView.sale?goodsFileTy=i&goodsFileSn="+obj.goodsImageSn}
                        type="type2"
                        prodName={obj.goodsNm}
                        disprice={"￦"+obj.sleAmount.toLocaleString('ko-KR')}
                        percent={Math.round(obj.dscntRate * 100)}
                        cost={"￦"+obj.nrmltAmount.toLocaleString('ko-KR')}
                        heart={true}
                        cart={true}
                        obj = {obj}
                    />
                    ))}     
                    </div>    
                ):(
                    <>
                     {dataList && dataList.map((obj, index) => (
                    
                        <Product2 key={index}
                            img={"https://www.salee.co.kr/com/cmm/getGoodsImageView.sale?goodsFileTy=i&goodsFileSn="+obj.goodsImageSn}
                            type="type5"
                            prodName={obj.goodsNm}
                            disprice={"￦"+obj.sleAmount.toLocaleString('ko-KR')}
                            percent={Math.round(obj.dscntRate * 100)}
                            cost={"￦"+obj.nrmltAmount.toLocaleString('ko-KR')}
                            heart={true}
                            cart={true}
                            obj = {obj}
                        />
                        ))}    
                    </> 
                )}

                <div id="observer" style={{ height: "10px" }}></div>

               
            </div>





            <Sheet isOpen={isOpen} onClose={() => setOpen(false)} className="bottomModal">
                <Sheet.Container>
                <Sheet.Header />
                <Sheet.Content>
                    <div className="dfColG16 btModalArea">
                        <div className="dfsb">
                            <h3 className="btModalTit">{t(`Message.goods_list_screen_filter_btn`)}</h3>
                            <button type="button" className="btn24 cFFF greenB dfcsG4 fs13" onClick={(e) => setTagCheckList([])} ><BsArrowClockwise /> {t(`Message.goods_list_screen_init_btn`)}</button>
                        </div>
                        <div className="modalTabWr">
                            <ul className="chkWr dfColG12">
                                {data.goodsInfoHashtagList && data.goodsInfoHashtagList.map((obj, index) => (
                                <li key={index}>
                                    <input type="checkbox"  id={"id_hashtag"+index}  
                                    checked={tagCheckList.includes(obj.hashtag) ? true : false} onChange={(e) => handleSingleCheck(e.target.checked, obj.hashtag)} />
                                    <label htmlFor={"id_hashtag"+index}>{obj.hashtag}</label>
                                </li>
                                ))}                                                                 
                            </ul>
                        </div>                        
                    </div>
                    <div className="btnWr">
                        <button type="button" className="btn40 wgB cDisa" onClick={() => setOpen(false)}>{t(`Message.common_cancel`)}</button>
                        <button type="button" className="btn40 orgB cFFF" onClick={() => fn_search()}>{t(`Message.goods_list_screen_filter_search_btn`)}</button>
                    </div>
                </Sheet.Content>
                </Sheet.Container>
                <Sheet.Backdrop onClick={() => setOpen(false)}/>
            </Sheet>
        </div>
    )
}